import { render, staticRenderFns } from "./ZDTwoColumnInput.vue?vue&type=template&id=238582d2&scoped=true&"
import script from "./ZDTwoColumnInput.vue?vue&type=script&lang=js&"
export * from "./ZDTwoColumnInput.vue?vue&type=script&lang=js&"
import style0 from "./input-highlight.css?vue&type=style&index=0&id=238582d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238582d2",
  null
  
)

export default component.exports